/**
 * Function returns true if all of the provided required fields have values set inside of form Object
 *
 * @param {Object} formObject Form
 * @param {Array} requiredFields Array of required fields
 * @returns {Boolean}
 */
export const areRequiredFieldsSet = (formObject, requiredFields) => {
  return requiredFields
    .map(requiredField => {
      if (formObject[requiredField]) return true;

      return false;
    })
    .every(field => field);
};
